import { Box, Grid } from '@mui/material';
import SaaSCard from 'page-sections/operator/home/Card';
import InvoiceTypeSummary from 'page-sections/operator/home/InvoiceTypeSummary';
import ParticipantSummary from 'page-sections/operator/home/ParticipantSummary';
import ProfessionSummary from 'page-sections/operator/home/ProfessionSummary';
import ReRegistrationStatus from 'page-sections/operator/home/ReRegistrationStatus';
import RoomAvailabilitySummary from 'page-sections/operator/home/RoomAvailabilitySummary';
import SponsorSummary from 'page-sections/operator/home/SponsorSummary';

import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from 'utils/axios';

const OperatorDashboard = () => {
    const navigate = useNavigate();
    const [checkinListData, setCheckinListData] = useState([]);
    const [dataSponsor, setDataSponsor] = useState();
    const [dataParticipant, setDataParticipant] = useState();
    const [typeInvoice, setTypeInvoice] = useState();
    const [roomAvailability, setRoomAvailability] = useState();
    const [professionSummary, setProfessionSummary] = useState();
    const [participantLocationSummary, setParticipantLocationSummary] = useState();

    const [dataPackage, setDataPackage] = useState();

    useEffect(() => {
        const getData = async () => {
            await axiosInstance.get('api/prv/summaries/checkin').then(({data}) => setCheckinListData(data)).catch(err => console.log(err));
            // await axiosInstance.get('api/prv/summaries/package').then(({data}) => setDataPackage(data)).catch(err => console.log(err));
            await axiosInstance
                .get('api/prv/summaries/sponsor')
                .then(({ data }) => {
                    setDataSponsor({
                        series: [
                            {
                                name: 'Registered',
                                data: data.map(
                                    (item) => item.registeredParticipant,
                                ),
                            },
                        ],
                        categories: data.map((item) => item.name),
                    });
                })
                .catch((err) => console.log(err));

            await axiosInstance
                .get('api/prv/summaries/participant')
                .then(({ data }) => {
                    setDataParticipant(data.general);
                    setTypeInvoice(data.type);
                })
                .catch((err) => console.log(err));

            await axiosInstance
                .get('api/prv/summaries/room-availability')
                .then(({ data }) => setRoomAvailability(data))
                .catch((err) => console.log(err));

            await axiosInstance
                .get('api/prv/summaries/professions')
                .then(({ data }) => setProfessionSummary(data))
                .catch((err) => console.log(err));

            await axiosInstance
                .get('api/prv/summaries/participant-locations')
                .then(({ data }) => setParticipantLocationSummary(data))
                .catch((err) => console.log(err));
        };
        getData();
    }, []);

    const checkInDate = ['2026-04-09', '2026-04-10', '2026-04-11'];

    const downloadCheckinData = async (date) => {
        let url;
        try {
            const response = await axiosInstance.get(
                `api/prv/checkin-logs/download/${date}`,
                {
                    responseType: 'arraybuffer',
                },
            );

            const blob = new Blob([response.data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });

            url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `Checkin Log ${date}.xlsx`;
            document.body.appendChild(a);
            a.click();
        } catch (error) {
            console.error('Error downloading PDF:', error);
        } finally {
            if (url) {
                window.URL.revokeObjectURL(url);
            }
        }
    };

    return (
        <Box pb={4} pt={2}>
            <Grid container spacing={3}>
                <Grid item container sx={12} spacing={3}>
                    {checkInDate.map((item, index) => 
                    <Grid item lg={4} xs={6} key={index} sx={{ cursor: 'pointer'}}
                        onClick={() => downloadCheckinData(item)}
                    >
                        <SaaSCard data={checkinListData.filter((data) => data.date === item)} date={item}/>
                    </Grid>
                    )}
                </Grid>
                
                <Grid item md={4} xs={12}>
                    {dataParticipant && (
                        <ParticipantSummary data={dataParticipant} />
                    )}
                </Grid>

                <Grid item md={4} xs={12}>
                    {typeInvoice && <InvoiceTypeSummary data={typeInvoice} />}
                </Grid>
                <Grid item md={4} xs={12} sx={{ cursor: 'pointer'}}
                    onClick={() => navigate('/dashboard/operator/registration')}
                >
                    <ReRegistrationStatus />
                </Grid>
                <Grid item md={12} xs={12}>
                    {dataSponsor && <SponsorSummary data={dataSponsor} />}
                </Grid>
                <Grid item md={12} xs={12}>
                    {participantLocationSummary?.citySummaries && (
                        <SponsorSummary
                            title="City Summary"
                            maxItems={10}
                            sortByValue={false}
                            data={{
                                series: [
                                    {
                                        name: 'Participants',
                                        data: Object.values(
                                            participantLocationSummary.citySummaries,
                                        ),
                                    },
                                ],
                                categories: Object.keys(
                                    participantLocationSummary.citySummaries,
                                ),
                            }}
                        />
                    )}
                </Grid>
                <Grid item md={12} xs={12}>
                    {participantLocationSummary?.provinceSummaries && (
                        <SponsorSummary
                            title="Province Summary"
                            maxItems={10}
                            sortByValue={false}
                            data={{
                                series: [
                                    {
                                        name: 'Participants',
                                        data: Object.values(
                                            participantLocationSummary.provinceSummaries,
                                        ),
                                    },
                                ],
                                categories: Object.keys(
                                    participantLocationSummary.provinceSummaries,
                                ),
                            }}
                        />
                    )}
                </Grid>
                <Grid item md={12} xs={12}>
                    {professionSummary && (
                        <ProfessionSummary data={professionSummary} />
                    )}
                </Grid>
                {/* <Grid item md={4} xs={12}>
                    {dataParticipant && <PaidSummary data={dataPackage} />}
                </Grid> */}
            </Grid>
        </Box>
    );
};

export default OperatorDashboard;
